import PrimaryButton from '@/components/Buttons/PrimaryButton';
import useThemeColors from '@/hooks/useThemeColors';
import { Send } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface TelegramGroup {
    id: number;
    title: string;
    telegram_group_url: string | null;
}

interface Props {
    group: TelegramGroup;
}

const TelegramGroupCard: React.FC<Props> = ({ group }) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    return (
        <div className="group relative overflow-hidden rounded-xl border border-gray-100 bg-white shadow-md transition-all duration-300 hover:shadow-xl">
            <div className="space-y-6 p-6">
                <div className="flex justify-center">
                    <div
                        className={`rounded-2xl p-4 ${colors.iconBg} transition-transform duration-300 group-hover:scale-110`}
                    >
                        <Send
                            className={`h-12 w-12 ${colors.iconColor}`}
                            strokeWidth={1.5}
                        />
                    </div>
                </div>

                <div className="text-center">
                    <h3 className="text-lg leading-snug font-semibold text-gray-900">
                        {group.title}
                    </h3>
                </div>

                <div className="flex justify-center">
                    {group.telegram_group_url ? (
                        <PrimaryButton
                            as="anchor"
                            href={group.telegram_group_url}
                            target="_blank"
                            size="md"
                        >
                            {t('channelsGroups.joinButton')}
                        </PrimaryButton>
                    ) : (
                        <div className="transform cursor-not-allowed rounded-lg bg-gray-400 px-6 py-2.5 text-sm font-medium text-white shadow-md">
                            {t('channelsGroups.joinButton')}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TelegramGroupCard;
